import { store } from "../../../redux/store";
import { loginURL } from "apiManager/APIConfig";
import { CallAPI } from "../../../apiManager/ApiCall";
import { setAuth } from "../../../redux/slices/authSlice";
import { userURL } from "apiManager/APIConfig";
import { setAllUsers } from "../../../redux/slices/userSlice";
import { Alert } from "reactstrap";

export const LoginCall = async (body) => {
  try {
    const response = await CallAPI({ url: loginURL, method: "POST", body });
    console.log("pippo response xxxx", response);

    if (
      response?.access_token &&
      (response?.role == "admin" ||
        response?.role == "prof" ||
        response?.role == "university_admin" ||
        response?.role == "student")
    ) {
      store.dispatch(setAuth(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAllUsersCall = async ({
  limit = 10,
  page = 1,
  search = "",
  university = "",
  occupation = "",
  country = "",
  role = "",
}) => {
  try {
    const params = new URLSearchParams({
      limit,
      page,
      ...(search && { search }),
      ...(university && { university }),
      ...(occupation && { occupation }),
      ...(country && { country }),
      ...(role && { role }),
    });

    const response = await CallAPI({
      url: `${userURL}?${params.toString()}`,
      method: "GET",
    });

    if (response) {
      store.dispatch(setAllUsers(response));
      return response;
    }
    return [];
  } catch (error) {
    return { status: 400 };
  }
};

/** Admin: get one user with full stats — GET /api/user/:id */
export const GetUserByIdCall = async (userId) => {
  try {
    const response = await CallAPI({
      url: `user/${userId}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Admin: update user status (active | inactive) — PATCH /api/user/:id/status */
export const UpdateUserStatusCall = async (userId, status) => {
  try {
    const response = await CallAPI({
      url: `user/${userId}/status`,
      method: "PATCH",
      body: { status },
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Admin: reset user password to default 12341234 — POST /api/user/:id/reset-password */
export const ResetUserPasswordCall = async (userId) => {
  try {
    const response = await CallAPI({
      url: `user/${userId}/reset-password`,
      method: "POST",
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Admin only: toggle user's earning tab — POST /api/user/:id/earning (avoids CORS issues with PATCH) */
export const UpdateUserEarningCall = async (userId, enabled_earning) => {
  try {
    const response = await CallAPI({
      url: `user/${userId}/earning`,
      method: "POST",
      body: { enabled_earning },
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

/** Admin only: toggle verified badge on app profile — POST /api/user/:id/profile-verified */
export const UpdateUserProfileVerifiedCall = async (userId, profile_verified) => {
  try {
    const response = await CallAPI({
      url: `user/${userId}/profile-verified`,
      method: "POST",
      body: { profile_verified },
    });
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
